import React from 'react';
import { useCPPDynamicConfig } from '../hooks/useCPPDynamicConfig';

export default (ChildComponent) => {
    const WithCPPDynamicConfig = (props) => {
        const cppConfig = useCPPDynamicConfig();
        return (<ChildComponent {...props} cppConfig={cppConfig} />);
    };

    WithCPPDynamicConfig.displayName = `WithCPPDynamicConfig(${ChildComponent.displayName || ChildComponent.name || 'Component'})`;

    return WithCPPDynamicConfig;
};
